import PracovnyKrokEnum from '../model/pracovnyKrok/PracovnyKrokEnum';
import { fetchLegislativnyMaterialDetail } from '../client/legislativnyMaterial/legislativnyMaterialDetailClient';
import { getActiveDocumentFormData } from '../client/external/evidencnaaplikacia/documentFormDataDetailClient';
import { ClientResponse } from '../model/ClientResponse';
import { FormDataResponse } from '../model/sprievodnyDokument/FormDataResponse';
import Uuid from '../model/Uuid';

export default async (
  type: string,
  year: number,
  index: number,
  typDokumentuKod: string,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<FormDataResponse<object>>> => {
  const {
    data: materialDetail,
  } = await fetchLegislativnyMaterialDetail(
    type,
    year,
    index,
    PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION,
    headers,
  );

  const {
    data: formData,
    responseCode,
  } = await getActiveDocumentFormData(materialDetail.uuid, typDokumentuKod, stadiumUuid);

  return {
    data: { formData, materialDetail },
    responseCode,
  };
};
